import { CanActivate, Router, CanActivateChild, ActivatedRoute, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { SettingsService } from "../settings/settings.service";
import { Injectable } from "@angular/core";
import * as jwt from 'jsonwebtoken';
import { MenuService } from "../menu/menu.service";

@Injectable()
export class AuthGuard implements CanActivateChild {

    constructor(private settings: SettingsService, private router: Router) {

    }

    canActivateChild(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot) {

        // console.log({token: this.settings.getUserSetting('token')});
        if (!this.settings.getUserSetting('token')) {
            this.router.navigate(['login']);
            return false;
        } else {

            const decodedToken: any = jwt.decode(this.settings.getUserSetting('token'));

            const expiryDate = new Date(decodedToken.exp * 1000);
            // console.log({decodedToken, expiryDate});
            if (expiryDate && (Date.now() > expiryDate.getTime())) {
                this.router.navigate(['/login']);
                return false;
            }

            return this.settings.isUserRouteAllowed(state.url) ? true : false;
        }
    }
}


// WEBPACK FOOTER //
// /builds/eveasoft/lea/lea-front/src/app/core/guards/auth.guard.ts